import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './about-peak/HeroSection';
import { AboutContentSection } from './about-peak/AboutContentSection';
export function AboutPeakPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-238">
      <SeoBar data-id="element-239" />
      <Header data-id="element-240" />
      <main className="flex-grow" data-id="element-241">
        <div className="w-full bg-gray-50 pb-20" data-id="element-242">
          <HeroSection data-id="element-243" />
          <AboutContentSection data-id="element-244" />
        </div>
      </main>
      <Footer data-id="element-245" />
    </div>;
}